var products = [{
            Men: [
                {
                    product: "Triathlon",
                    name: "Prana Core Men's Eco Triathlon Wetsuit Limited Edition",
                    price: 1299.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Fish Scale',
                                title: 'Next-gen',
                                content: 'Bio-Skin'
                            }, {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                                
                            }, {
                               icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                               
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }
                        ],
                        Performance: {
                            Performance: [
                                {
                                icon: 'Fish Scale',
                                title: 'Next-gen',
                                content: 'Bio-Skin'
                            }, {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                                
                            }, {
                               icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                               
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [

                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5,
                    buoyancy: 5,
                    speed: 5,
                    thermal: 5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Prana_Core_men_101396be-01f8-4a6a-a6f7-e87367534951.png?v=1741141387",
                    product_url: 'https://www.sumarpo.com/products/mens-victory-eco-wetsuit',
                    property: "Performance"
                },
                {
                    product: "Triathlon",
                    name: "Victory Men's Eco Triathlon Wetsuit",
                    price: 819.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }
                        ],
                        Performance: {
                            Performance: [
                                {
                                    icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [

                            ], ShoulderFlexibility: [
                                {
                                    icon: 'Buoyancy',
                                    title: 'More',
                                    content: 'Buoyancy'
                                }, {
                                    icon: 'Even Buoyancy',
                                    title: 'Even',
                                    content: 'Buoyancy'
                                }, {
                                    icon: '#45',
                                    title: 'Best',
                                    content: 'Shoulder Flexibility'
                                }, {
                                    icon: 'NANO SCS',
                                    title: 'Fastest',
                                    content: 'Hydrodynamic Coating'
                                }
                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 4.5,
                    speed: 5, thermal: 5,
                    image_url: "https://www.sumarpo.com/cdn/shop/files/5-12-10363089_1280x1800_13698e2f-b7c2-4ae5-85b5-0a76f2a55dbe_1800x1800.jpg?v=1779340370",
                    product_url: 'https://www.sumarpo.com/products/victory-mens-eco-triathlon-wetsuit-preorder',
                    property: "Performance,ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "Elite Pro Men's Eco Triathlon Wetsuit",
                    price: 699.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                                {
                                    icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [
                                {
                                    icon: 'Buoyancy',
                                    title: 'More',
                                    content: 'Buoyancy'
                                }, {
                                    icon: 'Leg Buoyancy',
                                    title: 'Leg',
                                    content: 'Buoyancy'
                                }, {
                                    icon: '#40',
                                    title: 'Better',
                                    content: 'Shoulder Flexibility'
                                }, {
                                    icon: 'NANO SCS',
                                    title: 'Fastest',
                                    content: 'Hydrodynamic Coating'
                                }
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4.5, buoyancy: 5,
                    speed: 4.5, thermal: 5,
                    image_url: "https://www.sumarpo.com/cdn/shop/files/27_947a7896-7f7f-4e4a-a660-87dc37422796_1800x1800.jpg?v=1754530995",
                    product_url: 'https://www.sumarpo.com/products/elite-pro-mens-eco-triathlon-wetsuit',
                    property: "Performance,Buoyancy"
                }, {
                    product: "Triathlon",
                    name: "Vanguard Men's Eco Triathlon Wetsuit",
                    price: 579.95,
                     optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Torso Buoyancy',
                                title: 'Torso',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                               {
                                icon: 'Torso Buoyancy',
                                title: 'Torso',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4, thermal: 5,
                    product_url: 'https://www.sumarpo.com/products/vanguard-mens-eco-triathlon-wetsuit',
                    image_url: "https://www.sumarpo.com/cdn/shop/files/vanguard_mens_wetsuit_1800x1800.jpg?v=1766129227",
                    property: "Speed"
                },
                {
                    product: "Triathlon",
                    name: "Vanguard Men's Eco Sleeveless Triathlon Wetsuit",
                    price: 449.95,
                    optionData: {
                        Price: [
                           
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: 'Sleeveless',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 4,
                    speed: 4, thermal: 3.5,
                    image_url: "https://www.sumarpo.com/cdn/shop/files/5-12-10363346_1280x1800_661cf347-63c1-4795-99d1-8a9980ab7980_1800x1800.jpg?v=1779340425",
                    product_url: 'https://www.sumarpo.com/products/mens-vanguard-sleeveless-wetsuit',
                    property: "ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "Race Men's Eco Triathlon Wetsuit",
                    price: 479.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], Buoyancy: [
                              {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 4,
                    speed: 4.5, thermal: 4.5,
                    image_url: "https://www.sumarpo.com/cdn/shop/files/18_0fe23e4c-d484-4766-abef-e08c7139fdff_1800x1800.jpg?v=1754883587",
                    product_url: 'https://www.sumarpo.com/products/mens-race-ll-Wetsuit',
                    property: "Buoyancy,Speed"
                },
                {
                    product: "Triathlon",
                    name: "Nova Men's Eco Triathlon Wetsuit",
                    price: 369.95,
                   optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                              
                            ], Buoyancy: [
                              {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [
                              {
                                icon: 'Buoyancy',
                                title: 'More',
                                content: 'Buoyancy'
                            },{
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 4,
                    speed: 4, thermal: 4.5,
                    image_url: "https://www.sumarpo.com/cdn/shop/files/37_1800x1800.jpg?v=1754883467",
                    product_url: 'https://www.sumarpo.com/products/nova-mens-eco-triathlon-wetsuit',
                    property: "Buoyancy,BodyStretch"
                },
                {
                    product: "Triathlon",
                    name: "Nova Men's Eco Sleeveless Triathlon Wetsuit",
                    price: 319.95,
                      optionData: {
                        Price: [
                           
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: 'Sleeveless',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 3.5,
                    speed: 3.5, thermal: 3,
                    image_url: "https://www.sumarpo.com/cdn/shop/files/5-12-10363397_1280x1800_d92f6e44-ab55-40de-9bed-a300e91aba78_1800x1800.jpg?v=1779340385",
                    product_url: 'https://www.sumarpo.com/products/mens-nova-sleeveless-Wetsuit',
                    property: "ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "N-Joy Men's Eco Triathlon Wetsuit",
                    price: 254.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                             
                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [
                                {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 3.5,
                    speed: 4, thermal: 4,
                    image_url: "https://www.sumarpo.com/cdn/shop/files/5-12-10363252_1280x1800_4377a06a-9ace-49f2-8e03-69cabe3d9367_1800x1800.jpg?v=1779340467",
                    product_url: 'https://www.sumarpo.com/products/mens-n-joy-ll-Wetsuit',
                    property: "BodyStretch"
                },
                {
                    product: "Swimrun",
                    name: "Current Men's Eco Swimrun Wetsuit",
                    price: 599.99,
                    flexibility: 5, buoyancy: 5,
                    speed: 5, thermal: 5,
                    describe: "The ultimate Swimrun Wetsuit for cold weather",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Current_Man_7a130b82-6013-407c-a660-f2f89cfe0ab0.png?v=1741141387",
                    product_url: "https://www.sumarpo.com/products/mens-current-Eco-Swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "X-Ray Men's Eco Swimrun Wetsuit",
                    price: 539.99,
                    flexibility: 4.5, buoyancy: 5,
                    speed: 4.5, thermal: 5,
                    describe: "Great all-around Swimrun Wetsuit with style",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/X-ray_Man_60b1bd5a-5c87-4e81-99e1-d411e2015181.png?v=1741141387",
                    product_url: "https://www.sumarpo.com/products/mens-x-ray-Eco-Swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Innovator Men's Eco Swimrun Wetsuit",
                    price: 467.99,
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4, thermal: 4.5,
                    describe: "Very comfortable during both swim and run",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Innovator_Man_7943925a-bb21-445e-921e-386cc9e3c95d.png?v=1741141386",
                    product_url: "https://www.sumarpo.com/products/mens-innovator-Eco-Swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Pro Men's Eco Swimrun Wetsuit",
                    price: 495.99,
                    flexibility: 5, buoyancy: 4.5,
                    speed: 5, thermal: 4,
                    describe: "The most advanced Swimrun wetsuit in our line up",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Pro_Man_98ce5bfb-008b-424b-ab3b-8d6ff9e614b5.png?v=1741141385",
                    product_url: "https://www.sumarpo.com/products/mens-Hyper-pro-Eco-Swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Fast Men's Eco Swimrun Wetsuit",
                    price: 334.99,
                    flexibility: 5, buoyancy: 4,
                    speed: 4, thermal: 3,
                    describe: "The ultimate hot weather Swimrun Wetsuit. Best for elite swimmers",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Fast_Man_82367580-e92e-4a75-9a18-6bb08cf96fe2.png?v=1741141386",
                    product_url: "https://www.sumarpo.com/products/mens-Hyper-fast-Eco-Swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Light Men's Eco Swimrun Wetsuit",
                    price: 299.99,
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4, thermal: 3.5,
                    describe: "A good all-arounder for beginners",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Light_Man_b30fe893-1383-442b-974f-c7f94cceb9b5.png?v=1741141385",
                    product_url: "https://www.sumarpo.com/products/mens-Hyper-light-Eco-Swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "TiTitanium Men's Thermal Open Water Swimming Wetsuit",
                    price: 549.95,
                    flexibility: 4, buoyancy: 4.5,
                    speed: 4.5, thermal: 5,
                    describe: "When temperatures drop, the Thermal keeps your body warm and your performance at full speed",
                    image_url: "https://www.sumarpo.com/cdn/shop/files/mens_thermal_wetsuit_1800x1800.jpg?v=1766129934",
                    product_url: "https://www.sumarpo.com/products/mens-thermal-titanium-eco-open-water-wetsuit-preorder",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Aspire-Pro Men's Open Water Swimming Wetsuit",
                    price: 459.95,
                    flexibility: 4, buoyancy: 4,
                    speed: 4.5, thermal: 4.5,
                    describe: "Help intermediate swimmers to gain a lot of speed",
                    image_url: "https://www.sumarpo.com/cdn/shop/files/5_6d1107e0-e75e-48c4-9938-5eb7e69de06a_1800x1800.jpg?v=1754530474",
                    product_url: "https://www.sumarpo.com/products/aspire-pro-mens-open-water-swimming-Wetsuit",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Aspire Men's Open Water Swimming Wetsuit",
                    price: 249.95,
                    flexibility: 4, buoyancy: 3.5,
                    speed: 3.5, thermal: 4,
                    describe: "Great for beginners to test out open water",
                    image_url: "https://www.sumarpo.com/cdn/shop/files/11_c420d23a-d247-4c4c-b91e-cdc2fa121353_1800x1800.jpg?v=1754530676",
                    product_url: "https://www.sumarpo.com/products/aspire-mens-open-water-swimming-Wetsuit",
                    ProductOptions: "Lower"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Nova Men's Eco Sleeveless Open Water Swimming Wetsuit",
                    price: 319.95,
                    flexibility: 5, buoyancy: 3.5,
                    speed: 3.5, thermal: 3,
                    describe: "For more comfortable swims in the summer",
                    image_url: "https://www.sumarpo.com/cdn/shop/files/5-12-10363397_1280x1800_d92f6e44-ab55-40de-9bed-a300e91aba78_1800x1800.jpg?v=1779340385",
                    product_url: "https://www.sumarpo.com/products/mens-nova-sleeveless-Eco-open-water-swimming-Wetsuit-Preorder",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "N-Joy Men's Eco Open Water Swimming Wetsuit",
                    price: 254.99,
                    flexibility: 4, buoyancy: 3.5,
                    speed: 4, thermal: 4,
                    describe: "Easily fit every body type",
                    image_url: "https://www.sumarpo.com/cdn/shop/files/5-12-10363252_1280x1800_4377a06a-9ace-49f2-8e03-69cabe3d9367_1800x1800.jpg?v=1779340467",
                    product_url: "https://www.sumarpo.com/products/mens-n-joy-Eco-open-water-swimming-Wetsuit",
                    ProductOptions: "Lower"
                }
            ],
            Women: [
                {
                    product: "Triathlon",
                    name: "Prana Core Women's Eco Triathlon Wetsuit",
                    price: 1299.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Fish Scale',
                                title: 'Next-gen',
                                content: 'Bio-Skin'
                            }, {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                                
                            }, {
                               icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                               
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }
                        ],
                        Performance: {
                            Performance: [
                                {
                                icon: 'Fish Scale',
                                title: 'Next-gen',
                                content: 'Bio-Skin'
                            }, {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                                
                            }, {
                               icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                               
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [

                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 4.5,
                    speed: 5, thermal: 5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Prana_Core_Women_f58b58cb-4ffc-4707-859c-f841f7829e5d.png?v=1741141388",
                    product_url: 'https://www.sumarpo.com/products/prana-core-womens-eco-triathlon-wetsuit',
                    property: "Performance"
                },
                {
                    product: "Triathlon",
                    name: "Victory Women's Eco Triathlon Wetsuit",
                    price: 819.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }
                        ],
                        Performance: {
                            Performance: [
                                {
                                    icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [

                            ], ShoulderFlexibility: [
                                {
                                    icon: 'Buoyancy',
                                    title: 'More',
                                    content: 'Buoyancy'
                                }, {
                                    icon: 'Even Buoyancy',
                                    title: 'Even',
                                    content: 'Buoyancy'
                                }, {
                                    icon: '#45',
                                    title: 'Best',
                                    content: 'Shoulder Flexibility'
                                }, {
                                    icon: 'NANO SCS',
                                    title: 'Fastest',
                                    content: 'Hydrodynamic Coating'
                                }
                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 4.5,
                    speed: 5, thermal: 5,
                    image_url: "https://www.sumarpo.com/cdn/shop/files/victory_women_2_-resized_1_1800x1800.png?v=1784705199",
                    product_url: 'https://www.sumarpo.com/products/victory-womens-eco-triathlon-wetsuit-preorder',
                    property: "Performance,ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "Elite Pro Women's Eco Triathlon Wetsuit",
                    price: 699.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                                {
                                    icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [
                                {
                                    icon: 'Buoyancy',
                                    title: 'More',
                                    content: 'Buoyancy'
                                }, {
                                    icon: 'Leg Buoyancy',
                                    title: 'Leg',
                                    content: 'Buoyancy'
                                }, {
                                    icon: '#40',
                                    title: 'Better',
                                    content: 'Shoulder Flexibility'
                                }, {
                                    icon: 'NANO SCS',
                                    title: 'Fastest',
                                    content: 'Hydrodynamic Coating'
                                }
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4.5, buoyancy: 5,
                    speed: 4.5, thermal: 5,
                    image_url: "https://www.sumarpo.com/cdn/shop/files/7_36379cf5-ad90-42c9-917f-237801bcb708_1800x1800.jpg?v=1764829854",
                    product_url: 'https://www.sumarpo.com/products/elite-pro-womens-eco-triathlon-wetsuit',
                    property: "Performance,Buoyancy"
                },
                {
                    product: "Triathlon",
                    name: "Vanguard Women's Eco Triathlon Wetsuit",
                    price: 559.99,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Torso Buoyancy',
                                title: 'Torso',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                               {
                                icon: 'Torso Buoyancy',
                                title: 'Torso',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4.5, thermal: 5,
                    image_url: "https://www.sumarpo.com/cdn/shop/files/vanguard_women_wetsuit_1800x1800.jpg?v=1766129437",
                    product_url: 'https://www.sumarpo.com/products/vanguard-womens-eco-triathlon-wetsuit-preorder',
                    property: "Speed"
                },
                {
                    product: "Triathlon",
                    name: "Vanguard Women's Eco Sleeveless Triathlon Wetsuit",
                    price: 449.95,
                    optionData: {
                        Price: [
                           
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: 'Sleeveless',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 4,
                    speed: 4, thermal: 3.5,
                    image_url: "https://www.sumarpo.com/cdn/shop/files/5-14-10364215_1280x1800_b60b6e87-a707-4919-8660-9c012cc51ddc_1800x1800.jpg?v=1779340947",
                    product_url: 'https://www.sumarpo.com/products/womens-vanguard-sleeveless-Wetsuit',
                    property: "ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "Race Women's Eco Triathlon Wetsuit",
                    price: 479.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], Buoyancy: [
                              {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 4,
                    speed: 4.5, thermal: 4.5,
                    image_url: "https://www.sumarpo.com/cdn/shop/files/1_0b82b087-dd98-4532-92e2-8895d32e4981_1800x1800.jpg?v=1754555268",
                    product_url: 'https://www.sumarpo.com/products/womens-race-ll-Wetsuit',
                    property: "Speed"
                },
                {
                    product: "Triathlon",
                    name: "Nova Women's Eco Triathlon Wetsuit",
                    price: 369.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                              
                            ], Buoyancy: [
                              {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [
                              {
                                icon: 'Buoyancy',
                                title: 'More',
                                content: 'Buoyancy'
                            },{
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 4,
                    speed: 4, thermal: 4.5,
                    image_url: "https://www.sumarpo.com/cdn/shop/files/6_6f7cf923-4a4e-4098-ad84-9c2676c79eb9_1800x1800.jpg?v=1754641187",
                    product_url: 'https://www.sumarpo.com/products/nova-womens-eco-triathlon-wetsuit',
                    property: "Buoyancy,BodyStretch"
                },
                {
                    product: "Triathlon",
                    name: "Nova Women's Eco Sleeveless Triathlon Wetsuit",
                    price: 319.95,
                    optionData: {
                        Price: [
                           
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: 'Sleeveless',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 3.5,
                    speed: 3.5, thermal: 3,
                    image_url: "https://www.sumarpo.com/cdn/shop/files/26_5ed75921-4853-4fc1-9c8c-e6fb96258d8e_1800x1800.jpg?v=1766125082",
                    product_url: 'https://www.sumarpo.com/products/womens-nova-sleeveless-Wetsuit',
                    property: "ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "N-Joy Women's Eco Triathlon Wetsuit",
                    price: 254.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                             
                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [
                                {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 3.5,
                    speed: 4, thermal: 4,
                    image_url: "https://www.sumarpo.com/cdn/shop/files/5-14-10364089_1280x1800_21c835bb-86fe-4877-b93e-f674166d593d_1800x1800.jpg?v=1779340962",
                    product_url: 'https://www.sumarpo.com/products/womens-n-joy-ll-Wetsuit',
                    property: "BodyStretch"
                },
                {
                    product: "Swimrun",
                    name: "Current Women's Eco Swimrun Wetsuit",
                    price: 599.99,
                    flexibility: 5, buoyancy: 5,
                    speed: 5, thermal: 5,
                    describe: "The ultimate Swimrun Wetsuit for cold weather",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Current_Woman_c8c6c597-acbf-494c-b1c3-3ad6a65b8ece.png?v=1741141387",
                    product_url: "https://www.sumarpo.com/products/womens-current-Eco-Swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "X-Ray Women's Eco Swimrun Wetsuit",
                    price: 539.99,
                    flexibility: 4.5, buoyancy: 5,
                    speed: 4.5, thermal: 5,
                    describe: "Great all-around Swimrun Wetsuit with style",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/X-Ray_Woman_9479a04c-3017-47e8-8fc5-ddc6035c11f1.png?v=1741141386",
                    product_url: "https://www.sumarpo.com/products/womens-x-ray-Eco-Swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Innovator Women's Eco Swimrun Wetsuit",
                    price: 467.99,
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4, thermal: 4.5,
                    describe: "Very comfortable during both swim and run",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Innovator_Woman_c45aea8e-7f36-499e-8c95-a65c52eafe10.png?v=1741141387",
                    product_url: "https://www.sumarpo.com/products/womens-innovator-Eco-Swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Pro Women's Eco Swimrun Wetsuit",
                    price: 495.99,
                    flexibility: 5, buoyancy: 4.5,
                    speed: 5, thermal: 4,
                    describe: "The most advanced Swimrun wetsuit in our line up",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Pro_Woman_d11146ca-6276-4a36-9dd3-5d7100246a37.png?v=1741141386",
                    product_url: "https://www.sumarpo.com/products/womens-Hyper-pro-Eco-Swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Fast Women's Eco Swimrun Wetsuit",
                    price: 334.99,
                    flexibility: 5, buoyancy: 4,
                    speed: 4, thermal: 3,
                    describe: "The ultimate hot weather Swimrun Wetsuit. Best for elite swimmers.",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Fast_Woman_cdb89b1e-e137-4891-8d6a-396070c7519b.png?v=1741141386",
                    product_url: "https://www.sumarpo.com/products/womens-Hyper-fast-Swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Light Women's Eco Swimrun Wetsuit",
                    price: 299.99,
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4, thermal: 3.5,
                    describe: "A good all-arounder for beginners",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Light_Woman_dc755c4e-a08f-4e82-90c7-925bbfd4fcfc.png?v=1741141385",
                    product_url: "https://www.sumarpo.com/products/womens-Hyper-light-Eco-Swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "TiTitanium Women's Thermal Open Water Swimming Wetsuit",
                    price: 549.95,
                    flexibility: 4, buoyancy: 4.5,
                    speed: 4.5, thermal: 5,
                    describe: "When temperatures drop, the Thermal keeps your body warm and your performance at full speed",
                    image_url: "https://www.sumarpo.com/cdn/shop/files/womens_thermal_wetsuit_1800x1800.jpg?v=1766129748",
                    product_url: "https://www.sumarpo.com/products/mens-thermal-titanium-eco-open-water-wetsuit-preorder",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Aspire-Pro Women's Open Water Swimming Wetsuit",
                    price: 459.95,
                    flexibility: 4, buoyancy: 4,
                    speed: 4.5, thermal: 4.5,
                    describe: "Help intermediate swimmers to gain a lot of speed",
                    image_url: "https://www.sumarpo.com/cdn/shop/files/19_9bbbb584-510d-49fd-b0b0-43d012f3d0d5_1800x1800.jpg?v=1754555691",
                    product_url: "https://www.sumarpo.com/products/aspire-pro-womens-open-water-swimming-Wetsuit",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Aspire Women's Open Water Swimming Wetsuit",
                    price: 249.95,
                    flexibility: 4, buoyancy: 3.5,
                    speed: 3.5, thermal: 4,
                    describe: "Great for beginners to test out open water",
                    image_url: "https://www.sumarpo.com/cdn/shop/files/16_ef55ad39-f1ac-4e00-b32e-acd90c888185_1800x1800.jpg?v=1761197736",
                    product_url: "https://www.sumarpo.com/products/aspire-womens-open-water-swimming-Wetsuit",
                    ProductOptions: "Lower"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Nova Women's Eco Sleeveless Open Water Swimming Wetsuit",
                    price: 319.95,
                    flexibility: 5, buoyancy: 3.5,
                    speed: 3.5, thermal: 3,
                    describe: "For more comfortable swims in the summer",
                    image_url: "https://www.sumarpo.com/cdn/shop/files/26_5ed75921-4853-4fc1-9c8c-e6fb96258d8e_1800x1800.jpg?v=1766125082",
                    product_url: "https://www.sumarpo.com/products/womens-nova-sleeveless-Eco-open-water-swimming-Wetsuit-Preorder",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "N-Joy Women's Eco Open Water Swimming Wetsuit",
                    price: 254.95,
                    flexibility: 4, buoyancy: 3.5,
                    speed: 4, thermal: 4,
                    describe: "Easily fit every body type",
                    image_url: "https://www.sumarpo.com/cdn/shop/files/5-14-10364089_1280x1800_21c835bb-86fe-4877-b93e-f674166d593d_1800x1800.jpg?v=1779340962",
                    product_url: "https://www.sumarpo.com/products/womens-n-joy-Eco-open-water-swimming-Wetsuit",
                    ProductOptions: "Lower"
                }
            ]
        }]
